import { render, staticRenderFns } from "./TabsNavigation.vue?vue&type=template&id=634fcc8a&"
import script from "./TabsNavigation.vue?vue&type=script&lang=js&"
export * from "./TabsNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports